import React, { useRef } from 'react'
import './styles.sass'
import { useAppContext } from '../../ContextProvider'

const d_color = '#8686ff'
const s_color = '#ffcd72'
const o_color = '#7ce97c'

export default function Map() {

  const mapRef = useRef()
  const appContext = useAppContext();

  function handleClick(ev, id) {
    appContext.toggleObj(id)
    if (appContext.closed) appContext.toggleClose()
  }

  return (
    <svg
   className='map__block'
   ref={mapRef}
   width="210mm"
   height="220mm"
   viewBox={`0 0 210 220`}
   version="1.1"
   id="svg5">
    <defs
     id="defs2"><rect
       x="211.12178"
       y="615.17343"
       width="170.42937"
       height="27.766582"
       id="rect8438" /><rect
       x="423.82227"
       y="445.48731"
       width="241.70056"
       height="31.14349"
       id="rect8016" /><rect
       x="211.12178"
       y="615.1734"
       width="170.42937"
       height="27.766582"
       id="rect8438-1" /><rect
       x="211.12178"
       y="615.1734"
       width="170.42937"
       height="27.766582"
       id="rect8438-6" /><rect
       x="211.12178"
       y="615.1734"
       width="170.42937"
       height="27.766582"
       id="rect8438-1-5" /></defs><g
     id="layer1"><g
       id="1_d" className='map__element' onClick={(ev) => handleClick(ev, '1_d')} style={{'fill': d_color}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 98.292106,135.53164 c 0.06333,0.44333 0.06333,9.68988 0.06333,9.68988 l 6.143254,0.0633 -0.0633,-1.51998 18.30311,0.0633 v -8.29656 z"
         id="path2905" /></g><path
       style={{"fill": "#ccc","fillOpacity":1}}
       d="m 77.899029,135.53164 v 14.81982 h 15.833135 v -14.81982 z"
       id="path2907" /><path
       style={{"fill": "#ccc","fillOpacity":1}}
       d="m 77.835696,152.82143 0.06333,31.9196 16.149796,-0.0633 -0.189997,-31.79293 z"
       id="path2909" /><path
       style={{"fill": "#ccc","fillOpacity":1}}
       d="m 77.899029,187.33766 c 0,0.38 0,13.67983 0,13.67983 h 15.896468 l -0.06333,-13.67983 z"
       id="path2911" /><g
       id="g7904" style={{"fill": "#ccc"}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 127.17174,158.71135 v 10.25988 h -6.20658 v -3.48329 h 2.97663 l -0.0633,-2.72331 h -2.91329 v -4.11661 z"
         id="path2921" /></g><g
       id="g7910"  style={{"fill": "#ccc"}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 132.91556,135.60253 0.0896,9.44919 h 8.19527 l -0.0448,-1.34349 9.09092,0.13435 v 1.52262 l 8.19527,-0.0896 -0.0448,-9.76266 z"
         id="path2925" /></g><g
        id="10_d" className='map__element' onClick={(ev) => handleClick(ev, '10_d')}  style={{'fill': d_color}}><g
         id="g2995"><rect
           style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
           id="rect2981"
           width="9.1804886"
           height="8.9117918"
           x="151.76913"
           y="148.05217" /><rect
           style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
           id="rect2983"
           width="12.404855"
           height="9.3596201"
           x="165.87576"
           y="147.78346" /><rect
           style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
           id="rect2985"
           width="6.3143845"
           height="2.3287094"
           x="160.50182"
           y="151.50046" /></g></g><path
       style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 109.94195,182.04237 -0.17913,7.65787 c 0,0 13.61399,0.0896 13.61399,-0.13435 0,-0.22391 -0.0448,-7.70265 -0.0448,-7.70265 z"
       id="path3003" /><g
       id="3_o" className='map__element' onClick={(ev) => handleClick(ev, '3_o')} style={{"fill": o_color}}><path
       style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 129.42249,172.99623 c 0,0.31348 -0.0448,3.22436 -0.0448,3.22436 l -3.1348,-0.0448 v 6.13526 l 3.17958,-0.0896 v 3.17958 l 27.67582,-0.0896 0.0448,-3.04524 c 0,0 3.1348,0.22392 3.1348,0 0,-0.22391 -0.17913,-6.09047 -0.17913,-6.09047 l -3.00045,0.0448 -0.0448,-3.26915 z"
        />
       <path
       style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 157.03304,182.49272 c 0.31666,0 3.26162,0.0317 3.26162,0.0317 l 0.095,-6.45992 -3.57829,0.0633 z"
       id="path3065" /></g><g
       id="g7863"><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 139.71159,190.50429 v 5.76326 l 13.10984,-0.0633 -0.19,-5.8266 z"
         id="path3007" /></g><g style={{'fill': o_color}}
       id="8_o" className='map__element' onClick={(ev) => handleClick(ev, '8_o')}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 155.22806,197.47087 v 3.54662 h -2.78663 l 0.0633,2.34331 -12.79317,0.12666 0.0633,-5.95326 z"
         id="path3011" /></g><path
       style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 159.47134,186.831 v 16.40313 l 6.77658,-0.12667 -0.12666,-16.59312 -6.77658,0.0633 z"
       id="path3015" /><path
       style={{"fill": "#ccc", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 175.58948,193.70258 0.0633,3.86329 -5.3516,-0.095 -0.0317,5.4466 c 0,0 6.26992,0.22166 6.20659,0.0633 -0.0633,-0.15833 -0.0317,-3.95828 -0.0317,-3.95828 l 5.22494,-0.0633 -0.0633,-5.41493 -5.95326,-0.0317 z"
       id="path3017" /><path
       style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 168.38359,176.08625 8.06092,-0.0448 -0.13435,11.2405 -8.1057,0.0448 z"
       id="path3021" /><path
       style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 183.34107,176.13103 c 0.2687,0 6.49352,0.0448 6.49352,0.0448 0,0 0.0448,15.53966 -0.13435,15.53966 -0.17913,0 -6.40395,-0.13435 -6.40395,-0.13435 z"
       id="path3023" /><g
       id="2_d" className='map__element' onClick={(ev) => handleClick(ev, '2_d')}  style={{'fill': d_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 163.14463,135.27831 c 0,0.82332 0,10.13321 0,10.13321 l 7.9799,-0.0633 0.0633,-1.51999 h 9.37322 l -0.0633,1.39332 h 9.75321 l -0.0633,-9.94321 z"
         id="path3029" /></g><g
       id="g7741"
       style={{"fill": "#ccc","fillOpacity":1}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 98.41877,147.43816 h 7.78991 v 21.4064 h -7.916574 z"
         id="path2915"/></g><g
       id="4_d" className='map__element' onClick={(ev) => handleClick(ev, '4_d')}  style={{'fill': d_color}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 107.34866,192.72093 -9.119887,-0.0633 0.06333,-22.35639 8.866557,0.0633 v 4.43328 l -2.78663,0.0633 0.25333,12.79317 h 2.7233 z"
         id="path2903" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 104.46703,187.81266 0.0633,-13.86983 c 0,0 -1.29832,-0.50666 -1.29832,-0.25333 0,0.25333 -0.18999,12.44484 -0.18999,12.44484 z"
         id="path3057" /></g><g
       id="6_d" className='map__element' onClick={(ev) => handleClick(ev, '6_d')}  style={{'fill': d_color}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 122.67514,204.43745 -0.0633,-3.67329 h -0.88665 l -0.0633,-1.39332 h 9.9432 l -0.12666,-5.63659 -13.36317,-0.0633 v 2.1533 l -19.949747,-0.19 0.06333,3.79996 20.013087,-0.0633 v 5.06661 z"
         id="path957" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 121.58549,201.03031 c 0.0224,-0.15674 0.0448,-2.59741 0.0448,-2.59741 0,0 -0.64936,-0.20152 -0.67175,-0.0448 -0.0224,0.15674 -0.0224,2.55262 -0.0224,2.55262 z"
         id="path3059" /></g><g
       id="g7901" style={{"fill": "#ccc"}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 112.4786,152.75809 c 0,0.44333 0,16.08647 0,16.08647 l 6.07992,-0.0633 -0.0633,-3.29329 h -2.78663 l -0.0633,-2.84997 h 2.78664 l 0.0633,-3.73662 -2.97663,-0.0633 -0.0633,-3.1033 3.1033,0.12667 -0.12666,-3.35663 -6.0166,-0.0633 z"
         id="path2917" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 118.4283,155.64287 0.0448,-3.04524 -0.47022,0.0224 z"
         id="path3061" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 118.4283,155.73243 c -0.0896,0.0224 -3.53785,-0.0224 -3.53785,-0.0224 0,0 -0.0224,-0.96283 0.0672,-0.98522 0.0896,-0.0224 1.99284,-0.0672 2.0824,-0.0224 0.0896,0.0448 1.38827,1.03001 1.38827,1.03001 z"
         id="path3063" /></g><path
       style={{"fill": o_color, "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 121.34515,67.069162 c 0,0.569995 -0.0633,4.813274 -0.0633,4.813274 l 34.00957,-0.126664 v -4.74994 z"
       id="7_o" className='map__element' onClick={(ev) => handleClick(ev, '7_o')}/><g
       id="3_s" className='map__element' onClick={(ev) => handleClick(ev, '3_s')} style={{'fill': s_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 95.125478,38.917137 c 0,0.157444 0.03167,6.644086 0.03167,6.644086 l -2.026642,-0.03149 0.06333,5.447523 1.86831,-0.03149 -0.03167,3.148858 c 0,0 5.984924,0.188931 5.984924,-0.03149 0,-0.220421 -0.0317,-3.873094 -0.0317,-3.873094 h 1.29832 l -0.0317,12.375004 7.53657,0.03149 0.095,-23.805355 -6.17492,0.06297 0.095,10.139316 -2.8183,-0.03149 0.0633,-10.107829 z"
         id="path3077" /></g><path
       style={{"fill": s_color, "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 122.79463,48.902895 c -0.0448,0.492611 0.17913,14.82313 0.17913,14.82313 l 6.2696,-0.04478 v -14.82313 z"
       id="8_s" className='map__element' onClick={(ev) => handleClick(ev, '8_s')} /><path
       style={{"fill": "#ccc", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 111.7186,53.864327 c 0.095,0.538326 0.0633,8.391562 0.0633,8.391562 h 2.40663 l -0.0633,-8.423228 z"
       id="path3081" /><path
       style={{"fill": o_color, "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 134.25905,52.575089 -0.0448,11.330067 h 17.51011 l 0.0896,-11.464415 z"
       id="6_o" className='map__element' onClick={(ev) => handleClick(ev, '6_o')}/><path
       style={{"fill": "#ccc", "fillOpacity":1, "strokeDasharray":"none"}}
       d="m 161.89008,53.157267 -0.0448,10.658325 7.29961,-0.04478 c 0,0 0.13435,-10.658324 -0.0896,-10.658324 -0.22392,0 -7.16526,0.04478 -7.16526,0.04478 z"
       id="path3087" /><path
       style={{"fill": "inherit",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 202.78244,211.35276 0.0896,-6.44874 -1.45544,0.0224 z"
       id="path3099" /><rect
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       id="rect3695"
       width="7.7344685"
       height="79.119659"
       x="195.12755"
       y="128.11382" /><rect
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       id="rect3697"
       width="7.6632433"
       height="85.110718"
       x="195.12756"
       y="29.306944" /><rect
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       id="rect3701"
       width="9.7967577"
       height="75.923843"
       x="61.642353"
       y="129.26172"
       ry="2.8850383e-14" /><rect
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       id="rect3703"
       width="9.8165531"
       height="87.539833"
       x="79.102348"
       y="29.068317"
       ry="2.9761519e-14" /><path
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 48.663613,7.7813534 c 0.179131,0.1343485 7.210041,4.7022006 7.210041,4.7022006 L 33.885266,40.831113 26.988703,35.949778 48.439698,7.512656 Z"
       id="path3729" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 95.790471,180.62441 c 0.01582,0.19 0,1.36165 0,1.36165 l 1.678313,-0.60166 z"
       id="path3731" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 137.81162,192.81593 c 0.0158,0.19 0,1.36165 0,1.36165 l 1.67831,-0.60166 z"
       id="path3731-9" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 124.6226,201.00167 c -0.0158,-0.19 0,-1.36165 0,-1.36165 l -1.67831,0.60166 z"
       id="path3731-9-3" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 162.46381,179.97526 c -0.0158,-0.19 0,-1.36165 0,-1.36165 l -1.67831,0.60166 z"
       id="path3731-9-3-5" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 168.22707,194.79507 c -0.0158,-0.19 0,-1.36165 0,-1.36165 l -1.67831,0.60166 z"
       id="path3731-9-3-5-8" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 157.55554,193.30675 c 0.0158,0.19 0,1.36165 0,1.36165 l 1.67831,-0.60166 z"
       id="path3731-9-3-5-8-2" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 153.15392,203.12329 c 0.19,-0.0158 1.36165,0 1.36165,0 l -0.60166,-1.67831 z"
       id="path3731-9-3-5-8-2-5" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 181.59024,170.8237 c 0.19,-0.0158 1.36165,0 1.36165,0 l -0.60166,-1.67831 z"
       id="path3731-9-3-5-8-2-5-2" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 191.75511,185.29519 c -0.0158,-0.19 0,-1.36165 0,-1.36165 l -1.67831,0.60166 z"
       id="path3731-9-3-5-8-2-5-2-4" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 149.5123,156.47888 c -0.19,0.0158 -1.36165,0 -1.36165,0 l 0.60166,1.67832 z"
       id="path3731-9-3-5-8-2-5-2-4-6" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 164.04012,154.08155 c 0.0158,0.19 0,1.36165 0,1.36165 l 1.67832,-0.60166 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 162.79642,155.47282 c -0.0158,-0.19 0,-1.36165 0,-1.36165 l -1.67832,0.60165 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 177.77731,144.1022 c 0.0158,0.19 0,1.36165 0,1.36165 l 1.67832,-0.60165 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 102.35221,133.65083 c -0.19,0.0158 -1.36165,0 -1.36165,0 l 0.60165,1.67832 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 154.32557,36.147044 c -0.19,0.0158 -1.36165,0 -1.36165,0 l 0.60165,1.67832 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 120.0746,54.760369 c 0.0158,0.19 0,1.36165 0,1.36165 l 1.67832,-0.60165 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 160.91656,91.616672 c 0.0158,0.19 0,1.36165 0,1.36165 l 1.67832,-0.60165 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3-7" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 146.61004,87.09097 c 0.19,-0.0158 1.36165,0 1.36165,0 l -0.60165,-1.67832 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3-7-5" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 115.34896,87.022201 c -0.0158,-0.19 0,-1.36165 0,-1.36165 l -1.67832,0.60165 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3-7-5-1" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 140.36076,65.755017 c 0.19,-0.0158 1.36165,0 1.36165,0 l -0.60165,-1.67832 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3-7-5-1-1" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 90.233036,49.541882 c 0.0158,0.19 0,1.36165 0,1.36165 l 1.67832,-0.60165 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3-7-5-1-1-7" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 34.534092,23.775767 c 0.09141,-0.167311 0.74966,-1.136706 0.74966,-1.136706 L 33.55145,22.217314 Z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3-7-5-1-1-7-2" /><path
       style={{"fill": "#777",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 18.957923,18.734002 c 0.09141,-0.167311 0.74966,-1.136706 0.74966,-1.136706 l -1.732302,-0.421747 z"
       id="path3731-9-3-5-8-2-5-2-4-6-4-1-1-2-8-3-7-5-1-1-7-2-5" /><g
       id="8_d" className='map__element' onClick={(ev) => handleClick(ev, '8_d')}  style={{'fill': d_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 12.718335,10.882237 -2.7765378,3.627413 2.8213208,1.5674 -6.4935162,8.598312 3.134801,2.283925 9.4044032,-12.225723 z"
         id="path3095" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 9.9417972,14.50965 3.2019748,2.060012 0.694135,-1.612183 -3.112409,-1.410661 z"
         id="path4248" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 18.808806,14.711173 -6.023297,-3.918501 -0.447828,0.828483 3.806544,3.067626 z"
         id="path5492" /></g><g
       id="7_s" className='map__element' onClick={(ev) => handleClick(ev, '7_s')} style={{'fill': s_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 33.408022,4.2095898 -11.598764,15.0022612 8.553529,5.866556 4.657418,-5.642641 -2.328709,-1.433052 7.299608,-9.5387515 z"
         id="path3093" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 21.818061,19.205594 c 0.03167,0.06333 8.470727,5.984925 8.470727,5.984925 l 4.734107,-5.763262 c 0,0 -2.374968,-1.630813 -2.438302,-1.630813 -0.06333,0 -10.766532,1.40915 -10.766532,1.40915 z"
         id="path5494" /></g><g
       id="g7951" style={{'fill': '#ccc'}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 102.50372,63.01588 c 0,0.253331 -0.0633,3.388292 -0.0633,3.388292 l 11.68485,-0.095 -0.0633,-2.659967 -9.43655,0.06333 -0.001,-0.831792 -2.12159,0.0168 z"
         id="path3083" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 102.44039,66.404172 -0.0158,-3.48329 0.31667,-0.01582 c 0,0 0.42749,2.469967 0.41166,2.644132 -0.0158,0.174164 -0.71249,0.85499 -0.71249,0.85499 z"
         id="path5496" /></g><g
       id="4_s" className='map__element' onClick={(ev) => handleClick(ev, '4_s')} style={{'fill': s_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 175.90614,45.282768 -0.0317,-6.269922 -55.70097,-0.348329 0.12666,6.618251 31.63461,-0.126664 -0.0317,2.659967 -4.43327,0.06333 0.0317,3.166628 12.44485,-0.06333 -0.0633,-3.166626 -4.81327,-0.03167 v -2.596634 z"
         id="path3091" /></g><g
       id="2_s" className='map__element' onClick={(ev) => handleClick(ev, '2_s')} style={{'fill': s_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 175.52614,79.197345 c 0,-0.07917 0.1425,-6.649916 0.1425,-6.649916 l -1.20332,-0.01585 z"
         id="path3071" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 120.52183,72.705758 v 6.776582 l 24.44636,0.06333 -0.0633,0.886656 -5.69993,3.166625 2.1533,3.166629 6.14326,-3.166629 6.20659,3.166629 2.34331,-3.293293 -5.4466,-2.849964 v -1.266651 l 24.88969,-0.126666 -0.12667,-6.713249 z"
         id="path3033" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 175.68447,79.197345 -0.0158,-6.681584 -1.25082,0.01582 0.64916,6.586585 0.4275,0.095 z"
         id="path3075" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 117.71177,74.988916 0.0121,2.351101 2.97634,-0.01119 c 0,0 0.0363,-2.362298 -0.0242,-2.3511 -0.0605,0.01119 -2.96426,0.01119 -2.96426,0.01119 z"
         id="path3069" /></g><g
       id="5_s" className='map__element' onClick={(ev) => handleClick(ev, '5_s')} style={{'fill': s_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 178.07528,74.558236 c 0,0.110831 0.0475,2.501635 -0.0158,2.5333 -0.0633,0.03167 -2.50164,0.06333 -2.50164,0.06333 l 0.0792,-2.6758 2.4383,-0.03167 z"
         id="path3073" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 179.13148,38.871532 v 2.060012 H 177.788 v 6.896563 l -3.85133,-0.08957 0.0896,21.316646 4.03045,0.08957 v 18.89837 l -4.33552,-0.137552 0.0317,7.409908 11.77985,-0.03167 -0.31073,-56.680975 -6.11286,0.02238 z"
         id="path3037" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 173.72395,87.89758 c 0.32468,0.03359 4.85894,-0.04478 4.85894,-0.04478 0,0 0.056,0.794895 0,0.817287 -0.056,0.02238 -4.07524,0.302284 -4.12002,0.246306 -0.0448,-0.05598 -0.73892,-1.01881 -0.73892,-1.01881 z"
         id="path5500" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 174.67846,40.931538 0.0644,2.704585 h 3.92622 l 0.0644,-2.704585 z"
         id="path3089" /></g><g
       id="6_s" className='map__element' onClick={(ev) => handleClick(ev, '6_s')} style={{'fill': s_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 165.87575,103.44843 c 0.35827,0 7.97135,0.0896 7.97135,0.0896 l -0.17913,-19.346203 -8.24005,0.268697 0.0896,5.373944 h -1.70175 l 0.0896,5.463511 h 1.70175 l -0.0784,8.172871 z"
         id="path3035" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 173.62319,84.214188 c -0.0896,0.04478 -8.19527,0.02238 -8.19527,0.02238 l -0.0224,5.799381 c 0,0 6.71743,-1.23153 6.73982,-1.365877 0.0224,-0.13435 1.47784,-4.455896 1.47784,-4.455896 z"
         id="path3045" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 173.8471,103.56039 -8.32961,0.0448 0.0224,-1.67936 c 0,0 7.322,-1.05239 7.41157,-0.89565 0.0896,0.15674 0.89566,2.53023 0.89566,2.53023 z"
         id="path3047" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 173.77993,95.286752 c 0,0 -0.0364,-7.403169 -0.0476,-7.39757 -0.0112,0.0056 -0.29109,0.01119 -0.29109,0.01119 z"
         id="path5502" /></g><g
       id="1_s" className='map__element' onClick={(ev) => handleClick(ev, '1_s')} style={{'fill': s_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 117.76686,72.563261 c -0.0158,0.221663 0.0317,7.37824 0.0317,7.37824 l -0.31666,-0.03167 z"
         id="path3039" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 117.76686,79.925668 -6.07992,0.095 0.0792,-1.314148 5.66826,0.427492 z"
         id="path3041" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 118.00286,95.141207 -7.50113,-0.134347 c 0,0 -0.15674,0.918049 0.17913,0.962832 0.33588,0.04478 6.82939,-0.515004 6.91896,-0.559787 0.0896,-0.04478 0.40304,-0.268698 0.40304,-0.268698 z"
         id="path3043" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 99.970419,77.693196 c 0,0 -2.295805,0.07917 -2.32747,0.01582 -0.03167,-0.06333 -0.06333,-1.551646 0.095,-1.567479 0.158332,-0.01582 2.232472,1.551647 2.232472,1.551647 z"
         id="path3049" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 99.821017,94.894902 0.111959,-4.791766 c 0,0 0.761314,4.612635 0.761314,4.702201 0,0.08957 -0.873273,0.08957 -0.873273,0.08957 z"
         id="path3051" /><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 118.04765,95.118816 -0.0896,7.165264 -20.241858,-0.2687 0.08957,-7.165259 h 2.239138 l -0.08956,-4.567854 h -3.403499 v -7.165261 l 3.493069,-0.08956 -0.08956,-5.373944 -2.328709,-0.08957 v -6.71743 H 110.0763 v 1.791314 l 7.70265,-0.08957 -0.17913,7.344391 -5.82177,-0.17913 v 5.105246 h 1.34348 l -0.0896,3.851328 h -1.43305 v 6.627865 z"
         id="path3031" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 117.92519,102.25039 -20.329742,-0.0317 0.095,-7.409903 10.861532,0.189997 6.26992,4.08495 z"
         id="path5504" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 97.690447,94.8009 c 0.0475,-0.0079 2.715383,0.02376 2.715383,0.02376 0,0 -0.0475,0.641241 -0.15041,0.641241 -0.10292,0 -2.335392,-0.01582 -2.36706,-0.06333 -0.03167,-0.0475 -0.197913,-0.60166 -0.197913,-0.60166 z"
         id="path5506" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 99.832214,94.805337 0.01119,-4.668615 c 0,0 0.526206,0 0.526206,0.07837 0,0.07837 0.0672,3.022843 0.056,3.201977 -0.0112,0.179131 -0.59337,1.388268 -0.59337,1.388268 z"
         id="path5508" /><path
         style={{"fill": "inherit","fillOpacity":1,"strokeDasharray":"none"}}
         d="m 99.938751,77.629866 c 0.01582,0.126664 0.01582,5.589095 0.01582,5.589095 l 1.013319,-0.01582 -0.11083,-5.224936 z"
         id="path5510" /></g><path
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 61.643622,204.99359 -0.04478,6.35917 141.177998,0.0224 -0.17913,-6.44873 z"
       id="path3097" /><rect
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       id="rect3725"
       width="114.68178"
       height="8.4107246"
       x="88.095047"
       y="21.549015"
       ry="2.8421709e-14" /><rect
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       id="rect3699"
       width="143.69609"
       height="16.90979"
       x="59.152599"
       y="113.36525"
       ry="2.8421709e-14" /><path
       style={{"fill": "#818181",fillOpacity:1,"strokeDasharray":"none"}}
       d="m 79.086513,29.829627 h 9.816544 L 88.871389,21.548898 56.583156,0.02239144 36.184559,0.04478287 79.131331,28.034078 Z"
       id="path3727" /><rect
       style={{"fill": o_color,"fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
       id="1_o"
       className='map__element' onClick={(ev) => handleClick(ev, '1_o')}
       width="14.487259"
       height="8.6430941"
       x="109.47173"
       y="181.7065"
       ry="2.8421709e-14" /><rect
       style={{"fill": o_color,"fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
       id="5_o"
       className='map__element' onClick={(ev) => handleClick(ev, '5_o')}
       width="14.35291"
       height="6.2919931"
       x="139.6106"
       y="189.99132"
       ry="2.8421709e-14" /><rect
       style={{"fill": d_color,"fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
       id="5_d" className='map__element' onClick={(ev) => handleClick(ev, '5_d')}
       width="6.9032469"
       height="17.258118"
       x="159.34468"
       y="186.41934"
       ry="2.8421709e-14" /><rect
       style={{"fill": o_color,"fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
       id="2_o"
       className='map__element' onClick={(ev) => handleClick(ev, '2_o')}
       width="8.8032236"
       height="11.906518"
       x="168.1479"
       y="175.68448"
       ry="2.8421709e-14" /><rect
       style={{"fill": d_color,"fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
       id="3_d"
       className='map__element' onClick={(ev) => handleClick(ev, '3_d')}
       width="6.9665794"
       height="16.339796"
       x="182.96773"
       y="175.93781"
       ry="2.8421709e-14" /><g
       id="7_d" className='map__element' onClick={(ev) => handleClick(ev, '7_d')} style={{'fill': d_color}}><path
         style={{"fill": "inherit", "fillOpacity":1, "strokeDasharray":"none"}}
         d="m 183.34107,149.7987 c 0,0.17913 0.0448,14.82313 0.0448,14.82313 l -6.49351,-0.0896 -0.0448,4.12002 h 4.92611 l -0.0448,-1.5674 1.8361,0.0896 -0.0448,5.32916 8.06092,-0.0448 c 0,0 0.0896,-7.79221 -0.17913,-7.79221 -0.2687,0 -1.92567,-0.0896 -1.92567,-0.0896 l 0.0448,-14.86791 z"
         id="path3027" /><rect
         style={{"fill": "inherit","fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
         id="rect7877"
         width="4.5599432"
         height="1.0133207"
         x="181.32108"
         y="166.31126"
         ry="2.8421709e-14" /><rect
         style={{"fill": "inherit","fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
         id="rect7879"
         width="2.0899739"
         height="2.7866318"
         x="189.49097"
         y="164.47461"
         ry="2.8421709e-14" /></g><g
       id="4_o" className='map__element' onClick={(ev) => handleClick(ev, '4_o')} style={{'fill': o_color}}><path
         style={{"fill": "inherit","fillOpacity":1}}
         d="m 160.41224,158.75528 v 7.34439 l -15.76357,-0.17914 0.0448,2.77654 h -13.30052 l 0.0448,-9.98658 6.94135,0.17913 v -2.14957 h 6.49352 v 1.92566 z"
         id="path2923" /><rect
         style={{"fill": "inherit","fillOpacity":1,"strokewidth":0,"strokeDasharray":"none"}}
         id="rect7881"
         width="8.6132259"
         height="2.9766295"
         x="131.60503"
         y="158.77469"
         ry="2.8421709e-14" /></g><text
       transform="matrix(0.26458333,0,0,0.26458333,0.7599905,0.37999526)"
       id="text8014"
       style={{"fontWeight":'bold', "font-size":"21.3333px","fontFamily":"sans-serif", "fill": "#FFF"}}><tspan
         x="423.82227"
         y="464.9513"
         id="tspan12759">Пр. Карла Маркса</tspan></text><text
       style={{"fontWeight":"bold","fontSize":"3.88056px", "fontFamily":"sans-serif", "fill": "inherit", "fillOpacity":1}}
       x="124.76511"
       y="209.12405"
       id="text8434"><tspan
         id="tspan8432"
         style={{'font-size':'3.88056px', 'fill': '#FFF'}}
         x="124.76511"
         y="209.12405">Ул. Блюхера</tspan></text><text
       style={{'fontWeight':'bold','fontSize':'3.88056px','fontFamily':'sans-serif','fill':'#ffffff','fillOpacity':1}}
       x="128.5825"
       y="26.860029"
       id="text8434-9"><tspan
         id="tspan8432-7"
         style={{'font-size':'3.88056px', 'fill': '#FFF'}}
         x="128.5825"
         y="26.860029">Ул. Новогодняя</tspan></text><text
       style={{'fontWeight':'bold','fontSize':'2.46944444px','fontFamily':'sans-serif','fill':"#ffffff","fillOpacity":1}}
       x="-10.239666"
       y="48.532158"
       id="text8434-9-7"
       transform="rotate(-52.642648)"><tspan
         id="tspan8432-7-3"
         style={{"font-size":"2.46944444px"}}
         x="-10.239666"
         y="48.532158">Ул. Немировича-Данченко</tspan></text><text
       transform="matrix(0,-0.26458333,0.26458333,0,-98.691319,246.69741)"
       id="text8436"
       style={{'fontWeight':'bold','fontSize':'14.6667px','fontFamily':'sans-serif','shapeInside':'url(#rect8438)','fill':'#ffffff',"fillOpacity":"1"}}><tspan
         x="211.12109"
         y="628.5547"
         id="tspan12761">Ул. Геодезическая</tspan></text><text
       transform="matrix(0,-0.26458333,0.26458333,0,-81.558834,144.99883)"
       id="text8436-0"
       style={{'fontWeight':'bold','fontSize':'14.6667px','fontFamily':'sans-serif','shapeInside':'url(#rect8438-6)','fill':'#ffffff',"fillOpacity":"1"}}><tspan
         x="211.12109"
         y="628.5547"
         id="tspan12763">Ул. Геодезическая</tspan></text><text
       transform="matrix(0,-0.26458333,0.26458333,0,34.086391,243.67092)"
       id="text8436-1"
       style={{'fontWeight':'bold','fontSize':'14.6667px','fontFamily':'sans-serif','shapeInside':'url(#rect8438-1)','fill':'#ffffff',"fillOpacity":"1"}}><tspan
         x="211.12109"
         y="628.5547"
         id="tspan12765">Ул. Космическая</tspan></text><text
       transform="matrix(0,-0.26458333,0.26458333,0,33.686127,145.50373)"
       id="text8436-1-2"
       style={{'fontWeight':'bold','fontSize':'14.6667px','fontFamily':'sans-serif','shapeInside':'url(#rect8438-1-5)','fill':'#ffffff',"fillOpacity":"1"}}><tspan
         x="211.12109"
         y="628.5547"
         id="tspan12767">Ул. Космическая</tspan></text></g></svg>
  )
}
